<dx-select-box
    #selectBox
    [dataSource]="localAgents"
    displayExpr="displayName"
    valueExpr="id"
    [disabled]="isDisabled"
    (selectedItemChange)="onSelectedItemChange($event)">
    <dx-validator>
        <dxi-validation-rule *ngIf="isRequired" type="required" [message]="'_pickers.msgLocalAgentRequired' | translate"></dxi-validation-rule>
    </dx-validator>
</dx-select-box>
